import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { initializeCrispSdk } from "./useCrispSession";
import { getFromStorage } from "../utils/storage";

const SEGMENT_MAP = {
  localhost: "brand_test",
  "127.0.0.1": "brand_test",
};

export const getCrispSegment = () =>
  SEGMENT_MAP[window.location.hostname] || "brand_test";

const pushIfCrisp = (args) => {
  if (typeof window.$crisp !== "undefined") {
    window.$crisp.push(args);
  }
};

export const syncCrispChatSession = () => {
  const segment = getCrispSegment();

  pushIfCrisp(["set", "session:segments", [[segment], true]]);
  pushIfCrisp([
    "set",
    "session:data",
    [
      [
        ["domain", window.location.hostname],
        ["brand_segment", segment],
        ["page_url", window.location.href],
        ["page_section", document.title],
      ],
    ],
  ]);

  try {
    const user = JSON.parse(getFromStorage("USER_DATA") || "null");
    if (user?.username) {
      pushIfCrisp(["set", "user:nickname", [user.username]]);
    }
  } catch {
    // ignore invalid storage
  }
};

export const openCrispChat = async () => {
  await initializeCrispSdk();
  syncCrispChatSession();
  pushIfCrisp(["config", "container:index", [1400]]);
  document.body.classList.add("crisp-chat-active");
  pushIfCrisp(["do", "chat:show"]);
  pushIfCrisp(["do", "chat:open"]);
};

export const closeCrispChat = () => {
  pushIfCrisp(["do", "chat:close"]);
  pushIfCrisp(["do", "chat:hide"]);
  document.body.classList.remove("crisp-chat-active");
};

const useCrispContext = (enabled = true) => {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    initializeCrispSdk()
      .then(() => syncCrispChatSession())
      .catch(() => {});
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    initializeCrispSdk()
      .then(() => syncCrispChatSession())
      .catch(() => {});
  }, [enabled, location]);
};

export default useCrispContext;
